import { ReactNode } from "react";
import { MessageProps } from "../../../typings/messages";
import './chat.css';

export interface MessageTextProps {
   message: MessageProps;
   position: string;
   renderTicks: any;
}

const MessageText = ({ message, position, renderTicks }: MessageTextProps) => {
   return (
      <>
         <div className={position === "left" ? "talk_group flip" : "talk_group w-clearfix"}>
            <div className={position === "left" ? "buble flip align-right" : "buble"}>
               <div className="chat-message">{message.text}</div>
            </div>
            {renderTicks()}
         </div>
      </>
   )

}

export default MessageText;